<template>
  <div class="space-y-4">
    <BaseCard>
      <BaseCardBody clear-padding>
        <dl>
          <div class="px-4 py-5 sm:px-6 border-b sm:grid sm:grid-cols-4 sm:gap-4 sm:items-center">
            <dt class="text-sm font-medium text-gray-800">General</dt>
          </div>
          <div
            class="even:bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center"
          >
            <dt class="text-sm font-medium text-gray-500">Date</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <ValidationProvider
                v-if="canEdit"
                rules="required"
                name="issue date"
                slim
                vid="issueDate"
              >
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput type="date" v-model="inputIssueDate" class="w-48" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
              <template v-else>
                {{ issueDate }}
              </template>
            </dd>
          </div>
          <div
            v-if="number"
            class="even:bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm font-medium text-gray-500">Number</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              {{ number }}
            </dd>
          </div>
          <div class="even:bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">Assigned to</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <ValidationProvider v-if="canEdit" name="assigned to" slim vid="assignedUserId">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormSelect
                      v-model="inputAssignedUser"
                      :options="memberOptions"
                      class="w-48"
                    />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
              <template v-else-if="assignedUser">
                {{ assignedUser ? assignedUser.fullName : 'Unassigned' }}
              </template>
              <template v-else> Not assigned yet. </template>
            </dd>
          </div>
        </dl>
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
export default {
  props: {
    issueDate: {
      type: String,
      required: true,
    },
    number: {
      type: String,
      required: true,
    },
    assignedUserId: {
      type: String,
      default: null,
    },
    accountId: {
      type: String,
      required: true,
    },
    canEdit: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    inputIssueDate: {
      get() {
        return this.issueDate;
      },
      set(issueDate) {
        this.$emit('update:issue-date', issueDate);
      },
    },
    inputAssignedUser: {
      get() {
        return this.assignedUserId;
      },
      set(assignedUserId) {
        this.$emit('update:assigned-user-id', assignedUserId);
      },
    },
    members() {
      return this.$store.getters['ui/accountMembers/membersByAccount'](this.accountId);
    },
    memberOptions() {
      return this.members.map((member) => ({
        value: member.id,
        label: member.fullName,
      }));
    },
  },
  created() {
    this.fetchAccountMembers();
  },
  methods: {
    setLoading(value) {
      this.loading = Boolean(value);
    },
    async fetchAccountMembers() {
      this.setLoading(true);
      try {
        await this.$store.dispatch({
          type: 'ui/accountMembers/load',
          accountId: this.accountId,
        });
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
